export default __webpack_public_path__ + "public/images/envmaps/fishermans_bastion/posx.jpg";